import liff from "@line/liff";
import { useState, useEffect } from "react";

const ProfilePage = () => {
  const [profile, setProfile] = useState<any>([]);

  const initializeLiff = async () => {
    await liff.init({ liffId: process.env.REACT_APP_LIFF_ID! });
    if (liff.isLoggedIn()) {
      setProfile(await liff.getProfile());
    } else {
      liff.login();
    }
  };

  const handleSendCardMessage = () => {
    liff.sendMessages([
      {
        type: "flex",
        altText: "Flex Message",
        contents: {
          type: "bubble",
          body: {
            type: "box",
            layout: "vertical",
            contents: [
              {
                type: "text",
                text: "Hello, " + profile.displayName + "!",
              },
              {
                type: "text",
                text: "This is a Flex Message",
              },
            ],
          },
        },
      },
    ]);
    // liff.closeWindow();
  };

  const handleSendImageMessage = () => {
    // const file = await liff.downloadFileUrl("https://picsum.photos/200/300");
    liff.sendMessages([
      {
        type: "image",
        originalContentUrl: "https://picsum.photos/200/300",
        previewImageUrl: "https://picsum.photos/200/300",
      },
    ]);
  };

  const handleSendMessage = () => {
    liff.sendMessages([
      {
        type: "text",
        text: "Hello, " + profile.displayName + "!",
      },
    ]);
    handleSendCardMessage();
    handleSendImageMessage();
    liff.closeWindow();
  };

  useEffect(() => {
    initializeLiff();
    document.title = "Profile";
  }, []);

  return (
    <div className="container mx-auto mt-[64px] dark:bg-gray-800">
      <div className="mb-16">
        <div className="bg-white w-full dark:bg-gray-800">
          <img
            alt="profil cover"
            src="https://picsum.photos/375/112"
            className="w-full mb-4 h-28"
          />
          <div className="flex flex-col items-center justify-center p-4 -mt-16">
            <span className="relative block">
              <img
                alt={profile.displayName}
                src={profile.pictureUrl}
                className="mx-auto object-cover rounded-full h-16 w-16  border-2 border-white dark:border-gray-800"
              />
            </span>
            <p className="mt-2 text-xl font-medium text-gray-800 dark:text-white">
              {profile.displayName}
            </p>
            <p className="mb-4 text-xs text-gray-400">
              {profile.statusMessage}
            </p>
            <p
              className="p-2 px-4 text-xs text-white bg-teal-500 rounded-full"
              onClick={handleSendMessage}
            >
              Message
            </p>
            <div className="w-full p-2 mt-4 rounded-lg">
              <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-200">
                <p className="flex flex-col">
                  Articles
                  <span className="font-bold text-black dark:text-white">
                    34
                  </span>
                </p>
                <p className="flex flex-col">
                  Followers
                  <span className="font-bold text-black dark:text-white">
                    455
                  </span>
                </p>
                <p className="flex flex-col">
                  Rating
                  <span className="font-bold text-black dark:text-white">
                    9.3
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
